import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { PermissionConst } from 'src/app/core/models/permission-const.model';
import { AccountsService } from 'src/app/core/services/accounts.service';
import { SessionManagerService } from 'src/app/core/services/session-manager.service';
import { ListTemplate } from 'src/app/shared/renderers/models/list-template';

@Component({
  selector: 'app-clinic-users-list',
  templateUrl: './clinic-users-list.component.html',
  styleUrls: ['./clinic-users-list.component.scss']
})
export class ClinicUsersListComponent implements OnInit {

  searchString: string = "";
  orderingItem: string = "name";

  request?: Subscription;

  get clinicId() {
    if(this.isSuperUserOrStaff) {
      return '';
    }
    return this.sessionManager.getClinicCurrent().value?.toString();
  }

  clinicIdList: string = "";

  get canNewData() {
    const permissions = [PermissionConst.add_account, PermissionConst.change_account, PermissionConst.view_account];
    return permissions.every((p) => this.sessionManager.getUserPermission(p));
  }

  get canExport() {
    const permissions = [PermissionConst.export_account, PermissionConst.change_account, PermissionConst.view_account];
    return permissions.every((p) => this.sessionManager.getUserPermission(p));
  }

  get isSuperUserOrStaff() {
    return this.sessionManager.isSuperUserOrStaff();
  }

  listTemplate: ListTemplate = {
    showSearch: true,
    searchBarPlaceholder: "Buscar por Nome de Usuário",
    showAdvancedSearch: false,
    newDataText: "+ Novo Usuário",
    newDataRouterLink: this.canNewData ? "register" : undefined,
    notFoundMessage: "Nenhum Usuário encontrado",
    clickRowClickHandle: true,
    header: [
      { name: "name", label: "Nome", widthInPercentage: "60%", width: "300px" },
      { name: "email", label: "E-mail", widthInPercentage: "40%", width: "300px" }
    ],
    onHeaderItemClick: (value: string) => {
      let invertString = '';
      if (this.orderingItem == value) {
        this.listTemplate.invertedOrdering = !this.listTemplate.invertedOrdering;
        if (this.listTemplate.invertedOrdering)
          invertString = '-';
      }
      let clinicId = this.clinicIdList != '' ? this.clinicIdList : this.clinicId;
      this.fetchList(this.searchString, `${invertString}${value}`, clinicId, this.listTemplate.is_active);
      this.orderingItem = value;
      this.listTemplate.selectedOrdering = value;
    },
    onSearchFocusOut: (value: string) => {
      this.searchString = value;
      let clinicId = this.clinicIdList != '' ? this.clinicIdList : this.clinicId;
      this.fetchList(value, this.orderingItem, clinicId, this.listTemplate.is_active);
    },
    onClinicFocusOut: (value: string) => {
      this.clinicIdList = value;
      let clinicId = this.clinicIdList != '' ? this.clinicIdList : this.clinicId;
      this.fetchList(this.searchString, this.orderingItem, clinicId, this.listTemplate.is_active);
    },
    onClickActive: !this.isSuperUserOrStaff ? undefined : () => {
      this.listTemplate.is_active = !this.listTemplate.is_active;
      let clinicId = this.clinicIdList != '' ? this.clinicIdList : this.clinicId;
      this.fetchList(this.searchString, this.orderingItem, clinicId, this.listTemplate.is_active);
    },
    selectedOrdering: this.orderingItem,
    invertedOrdering: false,
    exportUrl: this.canExport ? '/accounts/export' : undefined,
    exportOptions: {
      id: 'ID',
      name: 'Nome',
      email: 'E-mail',
      birthdate: 'Data de nascimento',
      document_number: 'CPF'
    }
  };

  constructor(private accountsService: AccountsService, private sessionManager: SessionManagerService, private titleService: Title) {
    this.titleService.setTitle('Chega de Ronco - Usuários de clínica');
  }

  ngOnInit(): void {
    this.initializeList();
  }

  initializeList() {
    this.fetchList("", "name", this.clinicId, this.listTemplate.is_active);
  }

  fetchList(searchString: string, orderingItem: string, clinicId: string, isActive: boolean | undefined) {
    this.listTemplate.loading = true;
    this.listTemplate.data = undefined;
    
    if (this.request) {
      this.request.unsubscribe();
    }
    this.request = this.accountsService.clinicUserList(searchString, orderingItem, clinicId, isActive).subscribe(response => {
      this.listTemplate.loading = false;
      this.listTemplate.data = response;
      this.listTemplate.hasNext = response.next != null;
    }, (error) => {
      const response = error as HttpErrorResponse;
      this.listTemplate.loading = false;
      this.listTemplate.error = true;
      this.listTemplate.errorMessage = response.error['detail'];
    });
  }

  loadMore(page: number) {
    this.listTemplate.loadingNext = true;
    let clinicId = this.clinicIdList != '' ? this.clinicIdList : this.clinicId;
    this.accountsService.clinicUserList(this.searchString, this.orderingItem, clinicId, this.listTemplate.is_active, page).subscribe(response => {
      this.listTemplate.hasNext = response.next != null;
      response.results!.map(item => this.listTemplate.data!.results!.push(item));
      this.listTemplate.loadingNext = false;
    }, error => {
      this.listTemplate.loadingNext = false;
    });
  }
}
